angular.module('vehicle-issue', ['core', 'vehicle'])
